import React, { Component } from 'react'
import styled from 'styled-components'
import { Shape, XXXMText } from './'

const CustomShape = styled(Shape)`
  width: 100px;
  padding: 0 6px;
  & button {
    border: none;
    background: transparent;
    font-size: 14px;
    color: #124b5f;
    padding: 2px 8px;
  }
`
class Counter extends Component {
  state = {}
  render() {
    const { value, onAdd, onSubtract, ...props } = this.props
    return (
      <CustomShape backgroundColor="transparent" border="1px solid #dcdcdc" {...props}>
        <button onClick={event => (onSubtract ? onSubtract(event) : null)}>-</button>
        <XXXMText color="#124b5f">{value}</XXXMText>
        <button onClick={event => (onAdd ? onAdd(event) : null)}>+</button>
      </CustomShape>
    )
  }
}

export default Counter



// WEBPACK FOOTER //
// ./src/components/Counter.js